import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFormControls, BaasicButton, BasicInput } from 'core/components';

function PatientEditModalTemplate({ patientEditModalViewStore, t }) {
    const {
        form,
        modalParams,
    } = patientEditModalViewStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Edit Patient Details</h3>
            </div>
            <div className="modal__body">
                <div className="row">
                    <div className="form__group col col-lrg-4">
                        <BasicInput field={form.$('ssn')} />
                    </div>
                    <div className="form__group col col-lrg-4">
                        <BasicInput field={form.$('height')} />
                    </div>
                    <div className="form__group col col-lrg-4">
                        <BasicInput field={form.$('weight')} />
                    </div>
                </div>
            </div>
            <div className='modal__footer'>
                <BaasicFormControls
                    form={form}
                    onSubmit={form.onSubmit}
                    disabled={form.submitting || form.validating}
                    label="Submit"
                    className='btn btn--med btn--rimary'
                />
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
            </div>
        </section>
    )
}

PatientEditModalTemplate.propTypes = {
    patientEditModalViewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(PatientEditModalTemplate);
